import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/PageLogin';
// components
import LoadingScreen from '../components/LoadingScreen';
import Page404 from '../pages/Page404';

// ----------------------------------------------------------------------

ClientGuard.propTypes = {
  children: PropTypes.node,
};

const PATH_WHITELIST = ['instruments', 'reports'];

export default function ClientGuard({ children }) {
  const { isAuthenticated, isInitialized, userRole } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  const isAllowed = useMemo(() => {
    if (userRole === 'T' || pathname === '/') {
      return true;
    }

    if (pathname.includes('edit') || pathname.includes('new')) {
      return false;
    }

    let matchFound = false;
    PATH_WHITELIST.forEach((val) => {
      if (pathname.includes(val)) {
        matchFound = true;
      }
    });

    return matchFound;
  }, [pathname]);

  // if (!isInitialized) {
  //   return <LoadingScreen />;
  // }

  // if (!isAuthenticated) {
  //   if (pathname !== requestedLocation) {
  //     setRequestedLocation(pathname);
  //   }
  //   return <Login />;
  // }

  if (!isAllowed) {
    return <Page404 />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
